{
  "activateFieldAllActiveErrorMessage": "Tous les champs sont actifs",
  "activateFieldDescription": "Le champ deviendra immédiatement visible sur les cartes de la ferme.",
  "activateFieldLinkTo": "Activer le champ",
  "activateFieldTitle": "Confirmer l'activation du champ",
  "archiveFieldAllArchivedErrorMessage": "Tous les champs sont archivés",
  "archiveFieldInstructions": "Le champ sera masqué sur les cartes de la ferme et ignoré dans les mises à jour sur l'emplacement de l'équipement. Cela n'aura aucun impact sur la collecte de données ; si vous réactivez le champ, toute activité sera immédiatement disponible.",
  "archiveFieldLinkTo": "Champ d'archives",
  "archiveFieldTitle": "Champ d'archives",
  "archiveFieldsHelpDescription": "Les champs archivés seront masqués sur la carte d'état, mais ne seront pas supprimés et pourront être réactivés à tout moment. Vous pouvez effectuer cette opération pour les champs qui ne sont pas utilisés pendant une saison donnée.",
  "areaAcresWithVal": "{{val}} acres",
  "confirmDeleteFieldInputLabel": "Entrez le nom du champ",
  "confirmDeleteFieldInstructions": "Le champ sera supprimé définitivement.\n\nCette action ne peut pas être annulée.",
  "confirmDeleteFieldLinkTo": "Supprimer le champ",
  "confirmDeleteFieldTitle": "Supprimer le champ",
  "enterFieldName": "Entrez le nom du champ",
  "fieldArchived": "Ce champ est archivé.",
  "fieldIrrigationHistoryLinkTo": "Afficher l'historique de l'irrigation",
  "fieldNameInputLabel": "Nom du champ",
  "fieldNameInputPlaceholder": "Comment s'appelle le champ ?",
  "fieldProfileLandingLinkTo": "Profil du terrain",
  "fieldProfileLandingTitle": "Profil du terrain",
  "fieldsRosterHelpDescription": "Affiche tous les champs appartenant à cette ferme. Vous pouvez archiver et activer les champs ici et également accéder au profil de chaque champ en cliquant/appuyant sur la fiche du champ dans la liste.",
  "fieldsRosterLinkTo": "Gérer les champs",
  "fieldsRosterListEmpty": "Votre compte de ferme n'a aucun champ",
  "fieldsRosterNewFieldButton": "Nouveau champ",
  "fieldsRosterSortKeys": {
    "alphabetical": "Nom du champ",
    "fieldStatus": "Statut du champ"
  },
  "fieldsRosterTitle": "Champs",
  "fieldsRosterTitleWithItemCount": "Champs ({{itemCount}})",
  "setFieldBoundaryInstructions": [
    "Dessinez votre terrain en appuyant sur la carte. Le terrain doit comporter au moins 3 points et être entièrement fermé.\n\nSi vous souhaitez recommencer, cliquez/appuyez sur Recommencer.\n\nVous pourrez également modifier la forme du terrain ultérieurement si nécessaire."
  ],
  "setFieldBoundaryTitle": "Dessiner les limites du champ",
  "setFieldLabelRotationDragSliderHint": "Déplacez le curseur pour ajuster la direction de l'étiquette",
  "setFieldLabelRotationInstructions": "Définissez la rotation de l'étiquette du champ selon vos besoins",
  "setFieldLabelRotationLabel": "Rotation",
  "setFieldLabelRotationTitle": "Définir la rotation des étiquettes",
  "setFieldNameInputLabel": "Nom du champ",
  "setFieldNameInstructions": "Entrez un nom pour le champ",
  "setFieldNameLinkTo": "Modifier l'étiquette",
  "setFieldNamePlaceholderText": "Comment s'appelle le champ ?",
  "setFieldNameTitle": "Entrez le nom du champ",
  "setFieldRowDirectionDragSliderHint": "Déplacez le curseur pour ajuster la direction de la ligne",
  "setFieldRowDirectionFlipButton": "Retourner",
  "setFieldRowDirectionInstructions": "Définir la direction de la ligne du champ",
  "setFieldRowDirectionLinkTo": "Définir la direction de la ligne",
  "setFieldRowDirectionTitle": "Définir la direction de la ligne",
  "sortFields": "Trier les champs",
  "updateFieldBoundaryInstructions": "Mettez à jour votre terrain en faisant glisser des points sur la carte. Le terrain doit avoir au moins 3 points et être entièrement fermé.",
  "updateFieldBoundaryTitle": "Dessiner les limites du champ"
}
